import { useState } from "react";
import { Box, IconButton, Typography, Snackbar, Alert } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { currentUser } from "@/App";

export default function CopyLink({ url }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  if (currentUser.role != "artist") {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        alignItems: "center",
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        color="secondary"
        noWrap
        sx={{ flexGrow: 1, minWidth: 0 }}
      >
        {url.replace("https://", "").replace("http://", "")}
      </Typography>
      <IconButton
        onClick={handleCopy}
        sx={{
          ml: "auto",
          mr: -1,
          "&:hover": {
            backgroundColor: "rgba(19,19,19)",
          },
        }}
      >
        <ContentCopy color="primary" />
      </IconButton>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} color="primary" variant="filled">
          Link copied to clipboard
        </Alert>
      </Snackbar>
    </Box>
  );
}
